// Mirrors Tp_Communication.Enum.InvoiceAutomationJobMonthRuleTextEnum — keep in sync.
const InvoiceAutomationJobMonthRuleEnum = {
  DateDone: 'DateDone',
  PrismRunStart: 'PrismRunStart',
  DateAdded: 'DateAdded',
};

export default InvoiceAutomationJobMonthRuleEnum;
